<template>
  <div>
    <main class="main-content">
      <div class="page-content">
        <div class="container">
          <div class="page-links">
            <router-link
              to="/settings/territory"
              class="page-links__item is-active"
              >Territory</router-link
            >
            <router-link to="/settings/location" class="page-links__item"
              >Location</router-link
            >
            <router-link to="/settings/area" class="page-links__item"
              >Area</router-link
            >
            <router-link to="/settings/airstrip" class="page-links__item"
              >Airstrip</router-link
            >
          </div>
          <div class="lds-ring" v-if="!isLoad">
            <div></div>
            <div></div>
            <div></div>
            <div></div>
          </div>
          <section class="geo-section geo-section--territory" v-if="isLoad">
            <div class="page-title">
              <h2>Setting & Data | Geo | Territory</h2>
            </div>
            <div class="geo-section__add">
              <div class="section-title">
                <h3>Add Territory</h3>
              </div>
              <form
                action="javascript:void(0)"
                class="geo-section__territory-form">
                <div class="add-block__container">
                <div class="form-control-group">
                  <span class="form-control-label">Title</span>
                  <div
                    :class="['form-control-wrap', {'is-error': errors.title}]">
                    <input
                      type="text"
                      Placeholder="Title"
                      @focus="errors.title = false"
                      v-model="add.title"
                      class="form-control" />
                  </div>
                </div>
                <div
                  :class="[
                    'form-control-group',
                    {'is-error': errors.territory},
                  ]">
                  <span class="form-control-label">Type of Territory</span>
                  <div
                    :class="['select-wrapper', {'is-active': typeSelect}]"
                    @click="
                      typeSelect = !typeSelect
                      errors.territory = false
                    ">
                    <div class="select-trigger">
                      <span class="select-trigger__name">{{
                        type || 'Choose'
                      }}</span
                      ><span class="select-trigger__icon">
                        <svg width="1em" height="1em" class="icon icon-chevron">
                          <use
                            xlink:href="/images/useful/svg/theme/symbol-defs.svg#icon-chevron"></use></svg
                      ></span>
                    </div>
                    <div class="select-body">
                      <div class="select-inner">
                        <div
                          v-for="item in types"
                          :key="item"
                          :class="[
                            'select-option',
                            {'is-selected': item === type},
                          ]"
                          @click="type = item">
                          <span class="select-option__name">{{ item }}</span>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
                <div
                  :class="[
                    'form-control-group',
                    {'is-error': errors.country},
                  ]">
                  <span class="form-control-label">Country</span>
                  <div
                    :class="[
                      'select-wrapper',
                      {'is-active': countrySelect},
                    ]"
                    @click="
                      countrySelect = !countrySelect
                      errors.country = false
                    ">
                    <div class="select-trigger">
                      <span class="select-trigger__name">{{
                        countries.find((item) => item.id === countryId)
                          ? countries.find((item) => item.id === countryId).name
                          : 'Choose'
                      }}</span
                      ><span class="select-trigger__icon">
                        <svg width="1em" height="1em" class="icon icon-chevron">
                          <use
                            xlink:href="/images/useful/svg/theme/symbol-defs.svg#icon-chevron"></use></svg
                      ></span>
                    </div>
                    <div class="select-body">
                      <div class="select-inner">
                        <div
                          v-for="item in countries"
                          :key="item.id"
                          :class="[
                            'select-option',
                            {'is-selected': item.id === countryId},
                          ]"
                          @click="countryId = item.id">
                          <span class="select-option__name">{{ item.name }}</span>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
                  <div class="form-control-group">
                    <span class="form-control-label">Place ID</span>
                    <div
                        :class="['form-control-wrap', {'is-error': errors.googlePlaceId}]">
                      <input
                          type="text"
                          Placeholder="Place ID"
                          @focus="errors.googlePlaceId = false"
                          v-model="googlePlaceId"
                          class="form-control" />
                    </div>
                  </div>
                </div>
                <button
                  type="submit"
                  class="btn btn--green geo-section__territory-form__submit"
                  @click="addTerritoryHandler">
                  <span>Add</span>
                </button>
              </form>
            </div>
            <div class="geo-section__territory">
              <div class="section-title">
                <h3>Territories</h3>
                <div class="form-control-wrap">
                  <input
                    type="text"
                    placeholder="Search"
                    v-model="search"
                    class="form-control-search" />
                  <div class="form-control-icon">
                    <svg width="1em" height="1em" class="icon icon-search">
                      <use
                        xlink:href="/images/useful/svg/theme/symbol-defs.svg#icon-search"></use>
                    </svg>
                  </div>
                </div>
              </div>
              <div data-simplebar="data-simplebar" class="section-table-wrap">
                <div class="section-table section-table--geo">
                  <div class="section-table__head">
                    <div class="col col-area"><span>Territory</span></div>
                    <div class="col col-country"><span>Country</span></div>
                    <div class="col col-added"><span>Added</span></div>
                    <div class="col col-edited"><span>Edited</span></div>
                  </div>
                  <div class="section-table__body">
                    <div
                      class="section-table__row"
                      v-for="(item, index) in territories.slice(
                        (page - 1) * 15,
                        (page - 1) * 15 + 15
                      )"
                      :key="index + 1">
                      <div class="col col-area">
                        <div class="section-table__row__number">
                          {{ index + 1 }}
                        </div>
                        <div class="section-table__row__name">
                          {{ item.names.EN }}
                        </div>
                      </div>
                      <div class="col col-country">
                        <span>{{ item.country ? item.country.name : '' }}</span>
                      </div>
                      <div class="col col-added">
                        <span>{{ item.createdAt }}</span>
                      </div>
                      <div class="col col-edited">
                        <span>{{ item.updatedAt }}</span>
                      </div>
                      <div class="col col-actions">
                        <button
                          type="button"
                          class="btn btn--edit"
                          @click="editTerritory(item)">
                          <svg width="1em" height="1em" class="icon icon-edit">
                            <use
                              xlink:href="/images/useful/svg/theme/symbol-defs.svg#icon-edit"></use>
                          </svg>
                        </button>
                        <button
                          type="button"
                          class="btn btn--remove"
                          @click="
                            $emit('deleteModalHandler', {
                              entity: 'Territory',
                              name: item.title,
                              handler: deleteTerritoryHandler,
                              id: item.id,
                            })
                          ">
                          <svg width="1em" height="1em" class="icon icon-close">
                            <use
                              xlink:href="/images/useful/svg/theme/symbol-defs.svg#icon-close"></use>
                          </svg>
                        </button>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              <Pagination
                :page="page"
                :pageCount="pageCount"
                @pageController="pageController" />
            </div>
          </section>
        </div>
      </div>
    </main>
    <div class="modal-wrapper" v-if="edit">
      <div class="modal-backdrop"></div>
      <div class="modal-inner">
        <div class="edit-popup edit-popup--territory">
          <div class="edit-popup__header">
            <div class="edit-popup__title">
              <div class="edit-popup__title__icon" :style="{minWidth: '21px'}">
                <svg width="1em" height="1em" class="icon icon-edit">
                  <use
                    xlink:href="/images/useful/svg/theme/symbol-defs.svg#icon-edit"></use>
                </svg>
              </div>
              <span :style="{whiteSpace: 'nowrap'}">Edit Territory</span>
            </div>
            <div
              class="form-control-group form-control-group-lang-horiz"
              :style="{justifyContent: 'flex-end', marginRight: '2rem'}">
              <span class="form-control-label">Language:</span>
              <div
                :class="[
                  'select-wrapper select-wrapper__lang',
                  {'is-active': selects.langEdit},
                ]"
                @click="changeSelects('langEdit')"
                :style="{width: '16rem'}">
                <div class="select-trigger">
                  <div class="select-trigger__flag__icon">
                    <svg
                      width="1em"
                      height="1em"
                      class="icon icon-rus"
                      :style="
                        langEdit === 'DE' || langEdit === 'ES'
                          ? {width: '18px', height: '18px', marginBottom: '1px'}
                          : {}
                      ">
                      <use
                        :xlink:href="getLanguageIcon(langEdit)"></use>
                    </svg>
                  </div>
                  <span class="select-trigger__name">{{getLanguageTitle(langEdit)}}</span
                  ><span class="select-trigger__icon">
                    <svg width="1em" height="1em" class="icon icon-chevron">
                      <use
                        xlink:href="/images/useful/svg/theme/symbol-defs.svg#icon-chevron"></use></svg
                  ></span>
                </div>
                <div class="select-body">
                  <div class="select-inner js-scrollbar">
                    <div
                      class="select-option"
                      @click="langEdit = 'RU'">
                      <span class="select-option__name">
                        <div class="select-trigger__flag__icon">
                          <svg width="1em" height="1em" class="icon icon-ru">
                            <use
                              xlink:href="/images/useful/svg/theme/symbol-defs.svg#icon-ru"></use>
                          </svg>
                        </div>
                        Russian
                      </span>
                    </div>
                    <div
                      class="select-option"
                      @click="langEdit = 'EN'">
                      <span class="select-option__name">
                        <div class="select-trigger__flag__icon">
                          <svg width="1em" height="1em" class="icon icon-usa">
                            <use
                              xlink:href="/images/useful/svg/theme/symbol-defs.svg#icon-usa"></use>
                          </svg>
                        </div>
                        English
                      </span>
                    </div>
                    <div
                      class="select-option"
                      @click="langEdit = 'DE'">
                      <span class="select-option__name">
                        <div class="select-trigger__flag__icon">
                          <svg
                            width="1em"
                            height="1em"
                            class="icon icon-rus"
                            :style="{
                              width: '18px',
                              height: '18px',
                              marginBottom: '1px',
                            }">
                            <use
                              xlink:href="/images/useful/svg/theme/symbol-defs.svg#icon-deu"></use>
                          </svg>
                        </div>
                        Deutch
                      </span>
                    </div>
                    <div
                      class="select-option"
                      @click="langEdit = 'ES'">
                      <span class="select-option__name">
                        <div class="select-trigger__flag__icon">
                          <svg
                            width="1em"
                            height="1em"
                            class="icon icon-es"
                            :style="{
                              width: '18px',
                              height: '18px',
                              marginBottom: '1px',
                            }">
                            <use
                              xlink:href="/images/useful/svg/theme/symbol-defs.svg#icon-es"></use>
                          </svg>
                        </div>
                        Spanish
                      </span>
                    </div>
                    <div
                      class="select-option"
                      @click="langEdit = 'FR'">
                      <span class="select-option__name">
                        <div class="select-trigger__flag__icon">
                          <svg
                            width="1em"
                            height="1em"
                            class="icon icon-es"
                            :style="{
                              width: '18px',
                              height: '18px',
                              marginBottom: '1px',
                            }">
                            <use
                              xlink:href="/images/useful/svg/theme/symbol-defs.svg#icon-fr"></use>
                          </svg>
                        </div>
                        French
                      </span>
                    </div>
                    <div
                      class="select-option"
                      @click="langEdit = 'PT'">
                      <span class="select-option__name">
                        <div class="select-trigger__flag__icon">
                          <svg
                            width="1em"
                            height="1em"
                            class="icon icon-es"
                            :style="{
                              width: '18px',
                              height: '18px',
                              marginBottom: '1px',
                            }">
                            <use
                              xlink:href="/images/useful/svg/theme/symbol-defs.svg#icon-pt"></use>
                          </svg>
                        </div>
                        Portuguese
                      </span>
                    </div>
                    <div
                      class="select-option"
                      @click="langEdit = 'NL'">
                      <span class="select-option__name">
                        <div class="select-trigger__flag__icon">
                          <svg
                            width="1em"
                            height="1em"
                            class="icon icon-es"
                            :style="{
                              width: '18px',
                              height: '18px',
                              marginBottom: '1px',
                            }">
                            <use
                              xlink:href="/images/useful/svg/theme/symbol-defs.svg#icon-nl"></use>
                          </svg>
                        </div>
                        Dutch
                      </span>
                    </div>
                  </div>
                </div>
              </div>
            </div>

            <div
              class="edit-popup__close"
              @click="
                isEdit
                  ? $emit('notLeavePopupHandler', {
                      handler: clearEdit,
                    })
                  : (edit = null)
              ">
              <svg width="1em" height="1em" class="icon icon-close">
                <use
                  xlink:href="/images/useful/svg/theme/symbol-defs.svg#icon-close"></use>
              </svg>
            </div>
          </div>
          <form action="javascript:void(0)" class="edit-popup__inner">
            <div class="edit-popup__side">
              <div class="form-control-group">
                <span class="form-control-label">Title</span>
                <div
                  :class="[
                    'form-control-wrap',
                    {'is-error': errorsEdit.title},
                  ]">
                  <input
                    type="text"
                    Placeholder="Title"
                    @change="isEdit = true"
                    v-model="edit.names[langEdit]"
                    @focus="errorsEdit.title = false"
                    class="form-control" />
                </div>
              </div>
            </div>
            <div class="edit-popup__side">
              <div class="form-control-group">
                <span class="form-control-label">Territory</span>
                <div
                  :class="['select-wrapper', {'is-active': typeEditSelect}]"
                  @click="
                    typeEditSelect = !typeEditSelect
                    errorsEdit.territory = false
                  ">
                  <div class="select-trigger">
                    <span class="select-trigger__name">{{
                      editType || 'Choose'
                    }}</span
                    ><span class="select-trigger__icon">
                      <svg width="1em" height="1em" class="icon icon-chevron">
                        <use
                          xlink:href="/images/useful/svg/theme/symbol-defs.svg#icon-chevron"></use></svg
                    ></span>
                  </div>
                  <div class="select-body">
                    <div class="select-inner">
                      <div
                        v-for="item in types"
                        :key="item"
                        :class="[
                          'select-option',
                          {'is-selected': item === editType},
                        ]"
                        @click="
                          editType = item
                          isEdit = true
                        ">
                        <span class="select-option__name">{{ item }}</span>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div class="edit-popup__side">
              <div
                :class="[
                  'form-control-group',
                  {'is-error': errorsEdit.country},
                ]">
                <span class="form-control-label">Country</span>
                <div
                  :class="[
                    'select-wrapper',
                    {'is-active': countryEditSelect},
                  ]"
                  @click="
                    countryEditSelect = !countryEditSelect
                    errorsEdit.country = false
                  ">
                  <div class="select-trigger">
                    <span class="select-trigger__name">{{
                      countries.find((item) => item.id === editCountryId)
                        ? countries.find((item) => item.id === editCountryId)
                            .name
                        : 'Choose'
                    }}</span
                    ><span class="select-trigger__icon">
                      <svg width="1em" height="1em" class="icon icon-chevron">
                        <use
                          xlink:href="/images/useful/svg/theme/symbol-defs.svg#icon-chevron"></use></svg
                    ></span>
                  </div>
                  <div class="select-body">
                    <div class="select-inner">
                      <div
                        v-for="item in countries"
                        :key="item.id"
                        :class="[
                          'select-option',
                          {'is-selected': item.id === editCountryId},
                        ]"
                        @click="
                          editCountryId = item.id
                          isEdit = true
                        ">
                        <span class="select-option__name">{{ item.name }}</span>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div class="edit-popup__side">
              <div class="form-control-group">
                <span class="form-control-label">Place ID</span>
                <div
                    :class="[
                    'form-control-wrap',
                    {'is-error': errorsEdit.googlePlaceId},
                  ]">
                  <input
                      type="text"
                      Placeholder="Place ID"
                      @change="isEdit = true"
                      v-model="edit.googlePlaceId"
                      @focus="errorsEdit.googlePlaceId = false"
                      class="form-control" />
                </div>
              </div>
            </div>

            <div class="edit-popup__side">
              <button
                type="submit"
                class="btn btn--green edit-popup__submit"
                @click="updateTerritoryHandler">
                <span>Save</span>
              </button>
            </div>
          </form>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import {
  getTerritoriesAll,
  createTerritory,
  deleteTerritory,
  getTerritory,
  updateTerritory,
  getCountries,
} from '@/utilites/api'

import Pagination from '@/components/Pagination'
import { getLanguageIcon, getLanguageTitle } from '../../common/helpers/language'


export default {
  props: ['user'],
  components: {Pagination},
  data() {
    return {
      isEditFlag: false,
      territories: [],
      territoriesData: [],
      countries: [],
      add: {
        names: {
          EN: '',
          RU: '',
          DE: '',
          ES: '',
          FR: '',
          PT: '',
          NL: '',
        },
      },
      page: 1,
      pageCount: 0,
      search: '',
      edit: null,
      type: '',
      types: ['Mainland', 'Island'],
      editType: '',
      editGooglePlaceId: null,
      googlePlaceId: null,
      countryId: null,
      editCountryId: null,
      typeSelect: false,
      typeEditSelect: false,
      countrySelect: false,
      countryEditSelect: false,
      isLoad: false,
      errors: {
        title: false,
        territory: false,
        country: false,
      },
      errorsEdit: {
        title: false,
        territory: false,
        country: false,
      },
      isEdit: false,
      selects: {
        territory: false,
        location: false,
        areas: false,
        territoryEdit: false,
        locationEdit: false,
        areasEdit: false,
        langEdit: false,
      },
      langEdit: 'EN',
    }
  },
  beforeCreate() {
    document.title = 'Setting & Data / Geo / Territory'
  },
  mounted() {
    this.updateData()
    getCountries().then((res) => {
      this.countries = res.sort((a, b) => a.name.localeCompare(b.name))
    })
    document.title = 'Setting & Data / Geo / Territory'
    window.addEventListener('click', (event) => {
      if (!event.target.closest('.select-wrapper')) {
        this.typeSelect = false
        this.typeEditSelect = false
        this.countrySelect = false
        this.countryEditSelect = false
      }
      if (
        !event.target.closest('.edit-popup') &&
        !event.target.closest('.btn')
      ) {
        if (this.isEdit) {
          this.$emit('notLeavePopupHandler', {
            handler: this.clearEdit,
          })
        } else {
          this.edit = false
        }
      }
    })
  },
  methods: {
    getLanguageTitle,
    getLanguageIcon,
    changeSelects(target) {
      this.selects = {
        territory: false,
        location: false,
        areas: false,
        territoryEdit: false,
        locationEdit: false,
        areasEdit: false,
        langEdit: false,
        [target]: !this.selects[target],
      }
    },
    checkErrors() {
      this.errors = {
        title:
          /[^A-Za-z0-9\- ]/g.test(this.add.title.trim()) ||
          this.add.title.trim().length === 0,
        territory: this.type.trim().length === 0,
        country: !this.countryId,
      }
      let error = false
      for (const key in this.errors) {
        if (this.errors[key]) {
          error = true
        }
      }
      return error
    },
    checkErrorsEdit() {
      this.errorsEdit = {
        title:
          /[^A-Za-z0-9\- ]/g.test(this.edit.names.EN.trim()) ||
          this.edit.names.EN.trim().length === 0,
        territory: this.editType.trim().length === 0,
        country: !this.editCountryId,
      }
      let error = false
      for (const key in this.errorsEdit) {
        if (this.errorsEdit[key]) {
          error = true
        }
      }
      return error
    },
    pageController(page) {
      this.page = page
    },
    pageCountHandler() {
      this.pageCount = Math.ceil(this.territories.length / 15)
    },
    addTerritoryHandler() {
      if (!this.checkErrors()) {
        createTerritory(this.user.access_token, {
          names: {
            EN: this.add.title,
            RU: this.add.title,
            DE: this.add.title,
            ES: this.add.title,
            FR: this.add.title,
            PT: this.add.title,
            NL: this.add.title,
          },
          type: this.type || null,
          countryId: this.countryId,
          googlePlaceId: this.googlePlaceId,
        }).then(() => {
          this.updateData()
          this.add = {
            title: '',
          }
          this.type = ''
          this.countryId = null
          this.googlePlaceId = ''
          this.$emit('confirmed')
        })
      }
    },
    editTerritory(item) {
      getTerritory(this.user.access_token, item.id).then((res) => {
        this.edit = res
        this.editType = res.type
        this.editCountryId = res.country ? res.country.id : null
        this.editGooglePlaceId = res.googlePlaceId
      })
    },
    updateTerritoryHandler() {
      if (!this.checkErrorsEdit()) {
        updateTerritory(this.user.access_token, {
          id: this.edit.id,
          names: this.edit.names,
          type: this.editType,
          countryId: this.editCountryId,
          googlePlaceId: this.edit.googlePlaceId,
        }).then((res) => {
          this.updateData()
          this.edit = null
          this.isEdit = false
          this.editType = ''
          this.editCountryId = null
          this.$emit('confirmed')
        })
      }
    },
    deleteTerritoryHandler(id) {
      deleteTerritory(this.user.access_token, id)
        .then(() => {
          this.updateData()
          this.$emit('confirmed')
        })
        .catch(() =>
          this.$emit(
            'errored',
            'You cannot delete Territory, if they have bound fields "Area"'
          )
        )
    },
    updateData() {
      this.isLoad = false
      getTerritoriesAll(this.user.access_token)
        .then((res) => {
          this.isLoad = true
          this.territories = res
            .map((item, index) =>
              index === 0
                ? {...item, active: true}
                : {
                    ...item,
                    active: false,
                  }
            )
            .sort(
              (a, b) =>
                new Date(b.createdAt).getTime() -
                new Date(a.createdAt).getTime()
            )
          this.territoriesData = res
            .map((item, index) =>
              index === 0
                ? {...item, active: true}
                : {
                    ...item,
                    active: false,
                  }
            )
            .sort(
              (a, b) =>
                new Date(b.createdAt).getTime() -
                new Date(a.createdAt).getTime()
            )
        })
        .catch(() => {
          this.isLoad = true
        })
    },
    clearEdit() {
      this.edit = null
      this.isEdit = false
      this.editCountryId = null
    },
  },
  watch: {
    territories() {
      this.pageCountHandler()
    },
    search() {
      if (this.search.length === 0) {
        this.territories = this.territoriesData
      }
      this.page = 1
      let filtered = this.territoriesData.filter((item) =>
        this.search.length
          ? item.names.EN &&
            item.names.EN.toLowerCase().includes(this.search.toLowerCase())
            ? item
            : false
          : item
      )
      this.territories = filtered
      this.pageCount = Math.ceil(filtered.length / 15)
    },
  },
}
</script>
<style scoped lang="scss">
.add-block__container {
  display: flex;
  margin: 10px 0;
}

.geo-section--territory .section-table--geo .col-area {
  width: 18rem;
}

.geo-section--territory .section-table--geo .col-country {
  width: 12rem;
  padding-right: 1rem;
  justify-content: center;
  color: #959595;
  font-size: 1.2rem;
  font-weight: 500;
  line-height: 1.16em;
  text-align: center;
}
</style>
